var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.svgClass},[_c('use',_vm._b({attrs:{"fill":"currentColor"}},'use',{'xlink:href': _vm.href},false))])}
var staticRenderFns = []

export { render, staticRenderFns }